import blowingsnow from './blowingsnow.png';
import clearnight from './clearnight.png';
import clearwindynight from './clearwindynight.png';
import cloudy from './cloudy.png';
import cloudywindy from './cloudywindy.png';
import drizzle from './drizzle.png';
import dust from './dust.png';
import flurries from './flurries.png';
import fog from './fog.png';
import fogdrizzle from './fogdrizzle.png';
import hail from './hail.png';
import hailrain from './hailrain.png';
import haze from './haze.png';
import heavyrain from './heavyrain.png';
import heavysnow from './heavysnow.png';
import icy from './icy.png';
import moonshowernight from './moonshowernight.png';
import moonsnownight from './moonsnownight.png';
import moontstormnight from './moontstormnight.png';
import mostlyclearnight from './mostlyclearnight.png';
import mostlycloudyday from './mostlycloudyday.png';
import mostlycloudynight from './mostlycloudynight.png';
import mostlysunnyday from './mostlysunnyday.png';
import na from './na.png';
import partlycloudyday from './partlycloudyday.png';
import partlycloudynight from './partlycloudynight.png';
import partlycloudywindyday from './partlycloudywindyday.png';
import partlycloudywindynight from './partlycloudywindynight.png';
import rain from './rain.png';
import rainsnow from './rainsnow.png';
import rainwind from './rainwind.png';
import sctdshowers from './sctdshowers.png';
import showers from './showers.png';
import smoke from './smoke.png';
import snow from './snow.png';
import snowice from './snowice.png';
import snowshowers from './snowshowers.png';
import snowthunder from './snowthunder.png';
import sunnyday from './sunnyday.png';
import sunnywindyday from './sunnywindyday.png';
import sunshowerday from './sunshowerday.png';
import sunsnowday from './sunsnowday.png';
import suntstormday from './suntstormday.png';
import tornado from './tornado.png';
import tstorm from './tstorm.png';
import windy from './windy.png';

export const ICON_PATH_MAP = {
  blowingsnow,
  clearnight,
  clearwindynight,
  cloudy,
  cloudywindy,
  drizzle,
  dust,
  flurries,
  fog,
  fogdrizzle,
  hail,
  hailrain,
  haze,
  heavyrain,
  heavysnow,
  icy,
  moonshowernight,
  moonsnownight,
  moontstormnight,
  mostlyclearnight,
  mostlycloudyday,
  mostlycloudynight,
  mostlysunnyday,
  na,
  partlycloudyday,
  partlycloudynight,
  partlycloudywindyday,
  partlycloudywindynight,
  rain,
  rainsnow,
  rainwind,
  sctdshowers,
  showers,
  smoke,
  snow,
  snowice,
  snowshowers,
  snowthunder,
  sunnyday,
  sunnywindyday,
  sunshowerday,
  sunsnowday,
  suntstormday,
  tornado,
  tstorm,
  windy,
};
